import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import KogAutoCompleteVehicleControlled from "@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled";

import { KeyValue } from "@/main/models/common";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { getManufacturers, resetReducerManufacturers, useManufacturerReducer } from "@/main/store/vehicle/manufacturer";
import { getModels, resetReducerModels, useModelReducer } from "@/main/store/vehicle/model";
import { getSubModels, resetReducerSubModels, useSubModelReducer } from "@/main/store/vehicle/subModel";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";

export const INITIAL_FORM_STATE_SUBMODEL = {
	manufacturer: null as KeyValue | null,
	model: null as KeyValue | null,
	subModel: null as KeyValue | null,
};

export type IFormFiltersMappingTypeSubModel = typeof INITIAL_FORM_STATE_SUBMODEL;

interface IFiltersMappingTypeSubModelProps {}
function FiltersMappingTypeSubModel(_props: IFiltersMappingTypeSubModelProps) {
	const dispatch = useDispatch();
	const { keyReducer, isRequiredField } = useDinamicFiltersMappingCodes();
	const { isolated: manufacturerReducer } = useManufacturerReducer(keyReducer);
	const { isolated: modelsReducer } = useModelReducer(keyReducer);
	const { isolated: subModelsReducer } = useSubModelReducer(keyReducer);
	const { control, resetField, setValue, watch } = useFormContext<IFormFiltersMappingTypeSubModel>();

	const watcherManufacturer = watch("manufacturer");

	const watcherModel = watch("model");

	useEffect(() => {
		dispatch(getManufacturers({}, keyReducer));

		return () => {
			dispatch(resetReducerManufacturers(keyReducer));
			dispatch(resetReducerModels(keyReducer));
			dispatch(resetReducerSubModels(keyReducer));
		};
	}, []);

	useEffect(() => {
		if (watcherManufacturer?.key) {
			dispatch(resetReducerModels(keyReducer));
			dispatch(resetReducerSubModels(keyReducer));
			resetField("model");
			resetField("subModel");
			dispatch(getModels({ guidManufacturer: String(watcherManufacturer?.key) }, keyReducer));
		}
	}, [watcherManufacturer?.key]);

	useEffect(() => {
		if (watcherManufacturer?.key && watcherModel?.key) {
			dispatch(resetReducerSubModels(keyReducer));
			resetField("subModel");
			dispatch(
				getSubModels(
					{
						guidManufacturer: String(watcherManufacturer?.key),
						guidModel: String(watcherModel?.key),
					},
					keyReducer,
				),
			);
		}
	}, [watcherModel?.key]);

	const disabledManufacturer = isNullUndefined(manufacturerReducer.data) || manufacturerReducer.data.length === 1;
	const disabledModel = isNullUndefined(modelsReducer.data) || modelsReducer.data.length === 1;
	const disabledSubMKodel = isNullUndefined(subModelsReducer.data) || subModelsReducer.data.length === 1;

	return (
		<>
			<KogAutoCompleteVehicleControlled
				id="id-mappingCode-select-manufacturer"
				nameCustom="manufacturer"
				label={getTranslateByKey("information.manufacturer")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={manufacturerReducer.data}
				isLoading={manufacturerReducer.isLoading}
				disabled={disabledManufacturer}
				rulesCustom={{ required: isRequiredField("manufacturer") }}
				onChangeCustom={() => {}}
			/>
			<KogAutoCompleteVehicleControlled
				id="id-mappingCode-select-model"
				nameCustom="model"
				label={getTranslateByKey("information.model")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={modelsReducer.data}
				isLoading={modelsReducer.isLoading}
				disabled={disabledModel}
				rulesCustom={{ required: isRequiredField("model") }}
				onChangeCustom={() => {}}
			/>

			<KogAutoCompleteVehicleControlled
				id="id-mappingCode-select-subModel"
				nameCustom="subModel"
				label={getTranslateByKey("information.subModel")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={subModelsReducer.data}
				isLoading={subModelsReducer.isLoading}
				disabled={disabledSubMKodel}
				rulesCustom={{ required: isRequiredField("subModel") }}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default FiltersMappingTypeSubModel;
